module.exports = __webpack_public_path__ + "static/media/adv-banner-img1.9608502d.png";